import { render, staticRenderFns } from "./UserAuthorization.vue?vue&type=template&id=6d27f46a&scoped=true"
import script from "./UserAuthorization.vue?vue&type=script&lang=ts"
export * from "./UserAuthorization.vue?vue&type=script&lang=ts"
import style0 from "./UserAuthorization.vue?vue&type=style&index=0&id=6d27f46a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d27f46a",
  null
  
)

export default component.exports